var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{attrs:{"id":"login"}},[_c('navbar',{attrs:{"title":"ログアウト"}}),_c('background-image',[_c('p',{staticClass:"page-title"},[_vm._v("ログアウトしました")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }